import { render } from "./ServicesContent.vue?vue&type=template&id=1d69afa7&scoped=true"
const script = {}

import "./ServicesContent.vue?vue&type=style&index=0&id=1d69afa7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d69afa7"]])

export default __exports__